const HIDE_OPTIONS_PRODUCT_IDS = new Set([
  '44', // giftcard
])

export const isFooterHiddenForProduct = (productId: number | string) => {
  return HIDE_OPTIONS_PRODUCT_IDS.has(String(productId))
}
